<template>
    <div>
        <CTabs
            variant="tabs"
            class="nav-tabs-boxed"
            :activeTab="abaAtiva"
            @update:activeTab="onTrocaAba"
        >
            <CTab title="Informações do Servidor">
              <InformacoesServidor />
            </CTab>
            <CTab title="Requisições">
                <LogsRequisicoes />
            </CTab>
            <CTab title="Logs de Integração">
                <LogsIntegracao v-if="integracaoMontada" />
            </CTab>
        </CTabs>
    </div>
</template>

<script>
  import LogsRequisicoes from "./requisicoes/LogsRequisicoes";
  import InformacoesServidor from "./InformacoesDeServidor/InformacoesServidor";
  import LogsIntegracao from "./integracao/LogsIntegracao";

  const ABA_INTEGRACAO = 2;

  export default {
    name: "Logs",
    components: {
      LogsRequisicoes,
      InformacoesServidor,
      LogsIntegracao
    },
    data() {
      // A tela da integração linka direto para a aba de integração, com o tipo
      // já escolhido. Sem isto, o link cairia em "Informações do Servidor" e o
      // usuário teria de refazer o filtro à mão.
      const abaDaRota = this.$route.query.aba === 'integracao' ? ABA_INTEGRACAO : 0;

      return {
        abaAtiva: abaDaRota,
        integracaoMontada: abaDaRota === ABA_INTEGRACAO,
      };
    },
    methods: {
      onTrocaAba(indice) {
        this.abaAtiva = indice;

        if (indice === ABA_INTEGRACAO) {
          this.integracaoMontada = true;
        }
      },
    },
  }
</script>